
    import "src/shared/components/AppLayout/index.module.scss?farm_css_modules";
    
    export default {"mainContainer": `mainContainer-8f14915c`}
    